/*
 * @Author: your name
 * @Date: 2020-06-11 16:24:48
 * @LastEditTime: 2020-06-23 10:43:08
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \client-v4\src\i18n\lang\it.js
 */
module.exports = {
    buyRegister: {
        mainName: 'Por favor ingrese su apellido',//姓
        firstName: 'Por favor, introduzca su nombre de pila',//名
        email: 'Por favor, introduzca su dirección de correo electrónico.',//邮箱
        confemail: 'Por favor confirme su dirección de correo electrónico.',//确认邮箱
        iphone: 'Ingrese su número de celular.',//电话号码
        num: 'Por favor, introduzca su número de teléfono.',//座机号码
        pwd: 'Por favor ingrese una contraseña.',//电话号码
        confpwd: 'Por favor, confirme su contraseña.',//密码
        errorEmail: 'Por favor revise su correo electrónico.',//输入一样的密码
        errorPwd: 'Por favor revise su contraseña.',//输入一样的密码
        emailType: 'Comprueba el formato de tu correo electrónico',//输入一样的邮箱地址
        pwdType: 'Comprueba el formato de tu contraseña',//密码格式不正确
        webSite: 'Ingrese la dirección de su sitio web',//网站地址
        confwebSite: 'Compruebe el formato de su sitio web',//网站地址不正确
        country: 'por favor seleccione su país',//国家
        intra: 'Ingrese el número de IVA de su empresa',//税号

        word1: 'Ingrese un número de calle',//街道号码
        word2: 'Inserisci un indirizzo',//地址
        word3: 'Por favor ingrese una ciudad.',//城市
        word4: 'Por favor, ingrese un número de teléfono.',//电话号码
        word5: 'Ingrese un nombre de contacto',//联系人姓
        word6: 'Ingrese un código postal',//邮编
        word7: 'Ingrese un número de calle',//请输入街道号码
        word8: 'Inserisci un indirizzo.',//请输入地址
        word9: 'Por favor ingrese una ciudad.',//请输入城市
        word10: 'Por favor, ingrese un número de teléfono.',//请输入联系电话
        word11: 'Ingrese un nombre de contacto',//请输入联系人姓
        word12: 'Ingrese un código postal',//请输入邮编
        word13: 'Ingrese un nombre de contacto',//请输入姓
        word14: 'Seleccione un idioma predeterminado',//请选择默认语言
        word15: 'Seleccione su área de actividad.',//请选择经营范围
        word16: 'Acepta las condiciones de uso y la política de privacidad.',//请同意使用条款
        word17: 'english address must input eori.',//英国地址必须填写eori号码
    },
    sellRegister: {
        sell1: 'Ingrese el nombre de su empresa',//请输入企业名称
        sell2: 'Por favor ingrese su apellido',//请输入商家姓
        sell3: 'Por favor, introduzca su nombre de pila',//请输入商家名
        sell4: 'Ingrese el número de IVA de su empresa',//请输入税号
        sell5: 'Ingrese el nombre de la tienda',//请输入店铺名称
        sell6: 'Esta dirección de correo electrónico ya está en uso',//您的邮箱地址已注册
        sell7: 'Ingrese un número de calle',//请输入街道号码
        sell8: 'Por favor ingrese una ciudad',//请输入商家城市
        sell9: 'Por favor ingrese una ciudad',//请输入商家城市
        sell10: 'Inserisci un indirizzo',//请输入地址
        sell11: 'Ingrese un código postal',//请输入邮编
        sell12: 'Sube una prueba de negocio',//请输入税号
        sell13: 'Por favor, introduzca el número del banco comercial',//请输入商家银行号
        sell14: 'Por favor, introduzca los datos del banco comercial',//请输入商家银行号
        sell15: 'Sube la identificación del administrador',//请上传商家身份证件
        sell16: 'Por favor ingrese su(s) marca(s)',//请添加商家品牌
        sell17: 'Ingrese sus categorías',//请选择商家产品目录
        sell18: 'Ingrese el monto mínimo de pedido deseado',//请填写最低订单要求
        sell19: 'Por favor, introduzca un número',//请输入有效数字
        sell20: 'Seleccione su campo de actividad'//请选择商家营业范围
    },
    account: {
        word1: "desconectar",//登出
        word2: "La dirección de correo electrónico no debe estar vacía", //email地址不能为空
        word3: "Los dos correos electrónicos son diferentes",//两个邮箱地址不一致
        word4: "Suscríbete a la newsletter de efashion paris",//是否订阅邮件
        word5: "Acepto recibir notificaciones sobre la aplicación",//是否接收手机应用的同志
        word6: "Acepto recibir sms",//是否接收订单更新的短信通知
    },
    seller_marques: {
        word1: "la marca se ha añadido a favoritos.",//添加收藏成功 商家
        word2: "la marca ha sido eliminada de favoritos.",//取消收藏成功 商家
        word3: "Inicie sesión para ejecutar esta acción.",//请先登录 再进行这个操作
    },
    product_detail: {
        word1: "El producto ha sido añadido a tu carrito",//产品已经添加到购物车
        word2: "La cantidad mínima de pedido es ",//最低订购数量为
        word3: "Colores",//颜色
        word4: "Paquetes",//包
        word5: "Cantidad",//数量
        word6: "Total",//总数
        word7: "Quantité ou montant acheté incorrect",//购买数量或者金额有误
    },
    goods_list: {
        couleurs:'Colores',
        melangees:'Colores mixtos',
        tailles:'Elige las tallas',
    },
    favor_articles: {
        word1: "¡Agregar a favoritos con éxito!",//添加收藏成功
        word2: "¡Eliminar a favoritos con éxito!",//取消收藏成功
        word3: "La operación falló. Vuelve a intentarlo.",//收藏操作失败
    },
    common: {
        yes: 'Si',//是
        no: 'No'//否
    },
    moncompte_articles: {
        word1: 'Uno o más artículos tienen defectos ',
        word2: 'Objetos perdidos',
        word3: 'Recibí uno o más artículos que no coinciden con mi pedido.',
        word4: 'Hola, tengo "número de artículos dañados" en mi pedido, se adjuntan las fotos como prueba (descargue las fotos). Por favor ayúdame con mi solicitud.',
        word5: 'Hola, acabo de recibir mi pedido, pero faltan algunoselementos: "completado por elcomprador". Informe alproveedor y comuníqueseconmigo.',
        word6: 'Hola, acabo de recibir mi pedido y "detallo el problema con precisión, referencia incorrecta, color, tamaño". Informe al proveedor y comuníquese conmigo.',
        word7: 'otro',
    },
    topMenuDesc: {
        'Accessoires': 'Accesorios',
        'Marques': 'Marcas',
        'Nouveautés': 'Noticias',
        'Outlet': 'Salida',
        'Vêtements': 'Ropa',
        'decouvrir': 'Descubrir',
        "AJOURD HUI": "NUEVA HOY",
        'CETTE SEMAINE': 'NUEVA SEMANA',
        'NOUVEAUX VENDEURS': 'NOUVEAUX VENDEDOR',
        'Nouveautés Vêtements': 'Ropa nueva',
        'Nouveautés Accessoires': 'Nuevos accesorios',
        'Tendances': 'Tendencia',
    },
    topMenuOutlet: {
        word1: 'Comprar a precios',
        word2: "Más de 5€",
        word3: "De 5 a 10€",
        word4: "De 10 a 15€",
        word5: 'Comprar con descuento',
        word6: "0 al 30%",
        word7: 'Del 30% al 50%',
        word8: 'Más del 50%',
        word9: 'Código promocional',
        word10: "descuentos",
        word11: "Todas las promociones",
        word12: "Oferta especial para la parte superior",
        word13: "Trajes de promoción y jumpsuits",
        word14: "Venta especial de zapatos",
        word15: "Ofertas especiales para artículos de cuero",
        word16: "Venta en tamaño grande",
        word17: "menos",
        word18: "5€",
        word19: "menos 5€",
    },
    topMenuNoLogin: {
        'preview catalog': 'Vista previa catálogo',
    },
    chooseCarte: {
        word1: 'eori can not empty',
        word2: 'english need eori,please add eori at address modify',
    },
    homeLogin: {
        word1: 'copiar',
    }
}
